export function indent(a: string, indentation: string, maxLines = 80): string {
  const lines = a.split('\n');
  const excessLineCount = lines.length - maxLines;
  return lines
    .slice(0, maxLines)
    .map((a) => `${indentation}${a}`)
    .concat(
      excessLineCount > 0
        ? [`${indentation}...${excessLineCount} more lines`]
        : [],
    )
    .join('\n');
}
